import { ChangeItemPayload, SyncItemPayload } from "./actions";
import { BasketState, QueueStatusEnum, init_state } from "./config";
import { ID } from "../../types/server";
export {
  create_basket_util,
  add_item_util,
  remove_item_util,
  sync_item_util,
  synced_item_util,
  sync_failed_item_util,
  reducer_logout_basket,
};

function create_basket_util(state: BasketState, payload): BasketState {
  return {
    ...state,
    data: payload,
    // reset basket and use server's data
    queue: init_state.queue,
  };
}

function change_quantity(
  state: BasketState,
  payload: ChangeItemPayload,
  cb: (quantity?: number) => number
) {
  let clonedState = JSON.parse(JSON.stringify(state));
  let { product_id } = payload;
  let { items } = clonedState.queue;
  // let targeted_item = items && items[product_id];
  let targeted_item = items[product_id];

  // update the quantity only.
  if (targeted_item) {
    let nextQuantity = cb(targeted_item.quantity);
    items[product_id] = {
      ...targeted_item,
      quantity: nextQuantity,
      status: QueueStatusEnum.NOT_SYNCED,
    };
  } else {
    // create a new entry
    let item_in_basket = clonedState.data.items.find(
      (item) => item.product_id === product_id
    );

    let quantity = cb(item_in_basket?.quantity);

    // I don't know why items hasn't been initialized
    // so we need to make sure it exists.
    if (!items) {
      clonedState.queue.items = {};
    }

    clonedState.queue.items[product_id] = {
      quantity,
      status: QueueStatusEnum.NOT_SYNCED,
    };
  }

  return clonedState;
}

function add_item_util(state, payload: ChangeItemPayload) {
  return change_quantity(state, payload, (q) => (q ? q + 1 : 1));
}

function remove_item_util(state, payload: ChangeItemPayload) {
  return change_quantity(state, payload, (q) => (q && q - 1 >= 1 ? q - 1 : 0));
}

function change_status_item(
  state,
  { product_id, status }: { product_id: ID; status: QueueStatusEnum }
) {
  let clonedState = JSON.parse(JSON.stringify(state));
  let { items } = clonedState.queue;

  // I don't know why items hasn't been initialized
  // so we need to make sure it exists.
  if (!items || !items[product_id]) {
    return state;
  }

  let ids = Object.keys(clonedState.queue.items);
  clonedState.queue.items[product_id].status = status;

  // We don't need synced items anymore
  // let filtredItems = {};
  // Object.entries<any>(clonedState.queue.items).forEach(([key, val]) => {
  //   if (val.status !== QueueStatusEnum.SYNCED) {
  //     filtredItems[key] = val;
  //   }
  // });
  // clonedState.queue.items = filtredItems;

  return clonedState;
}

// function remove_item_from_queue(
//   state,
//   { product_id }: { product_id: string | number }
// ) {
//   let { items } = state.queue;

//   if (items[product_id]) {
//     delete state.queue.items[product_id];
//   }

//   return state;
// }

function sync_item_util(state, payload: SyncItemPayload) {
  return change_status_item(state, {
    product_id: payload.product_id,
    status: QueueStatusEnum.LOADING,
  });
}

function synced_item_util(state, payload: SyncItemPayload) {
  return change_status_item(state, {
    product_id: payload.product_id,
    status: QueueStatusEnum.SYNCED,
  });
}

function sync_failed_item_util(state, payload: SyncItemPayload) {
  return change_status_item(state, {
    product_id: payload.product_id,
    status: QueueStatusEnum.NOT_SYNCED,
  });
}

function reducer_logout_basket(state) {
  return init_state;
}
